import React from 'react';
import { UserRound, ShieldCheck, BellRing, Lock, Star, CreditCard, Receipt, Volume2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { HostActionRow } from '../../components/HostSettingsCard';
import { HostSettingsLayout } from '../../components/HostSettingsLayout';

export default function GuestSettingsPage() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const iconColor = 'var(--text)';
  const items = [
    { label: 'Personal Information', icon: <UserRound size={22} color={iconColor} strokeWidth={1.6} />, action: () => navigate('/guest/settings/personal'), testId: 'guest-settings-personal-button' },
    { label: 'Login & Security', icon: <ShieldCheck size={22} color={iconColor} strokeWidth={1.6} />, action: () => navigate('/guest/settings/security'), testId: 'guest-settings-security-button' },
    { label: 'Payment Method', icon: <CreditCard size={22} color={iconColor} strokeWidth={1.6} />, action: () => navigate('/guest/settings/payment-method'), testId: 'guest-settings-payment-method-button' },
    { label: 'Payment History', icon: <Receipt size={22} color={iconColor} strokeWidth={1.6} />, action: () => navigate('/guest/history'), testId: 'guest-settings-payment-history-button' },
    { label: 'Ratings & Reviews', icon: <Star size={22} color={iconColor} strokeWidth={1.6} />, action: () => navigate('/guest/ratings'), testId: 'guest-settings-ratings-button' },
    { label: 'Privacy', icon: <Lock size={22} color={iconColor} strokeWidth={1.6} />, action: () => navigate('/guest/settings/privacy'), testId: 'guest-settings-privacy-button' },
    { label: 'Notifications & History', icon: <BellRing size={22} color={iconColor} strokeWidth={1.6} />, action: () => navigate('/guest/settings/notifications'), testId: 'guest-settings-notifications-button' },
    { label: 'Sound & Vibration', icon: <Volume2 size={22} color={iconColor} strokeWidth={1.6} />, action: () => navigate('/guest/settings/feedback'), testId: 'guest-settings-feedback-button' },
  ];

  return (
    <HostSettingsLayout title="Account Settings" dataTestId="guest-settings-page">
      {items.map((item) => (
        <HostActionRow key={item.label} label={item.label} icon={item.icon} onClick={item.action} dataTestId={item.testId} />
      ))}
      <p data-testid="guest-settings-account-id" style={{ marginTop: 18, textAlign: 'center', fontFamily: "'Inria Serif', serif", fontSize: 16, color: 'var(--text-2)' }}>
        Account ID: {user.customer_id || '—'}
      </p>
    </HostSettingsLayout>
  );
}
